import React from 'react';

const BakerCharacter = ({ width = 220, height = 310, style = {} }) => (
  <svg
    viewBox="0 0 240 348"
    width={width}
    height={height}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="bkSkin" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#fff0e0" />
        <stop offset="100%" stopColor="#f2b880" />
      </radialGradient>
      <radialGradient id="bkHead" cx="38%" cy="32%" r="65%">
        <stop offset="0%" stopColor="#fff0e0" />
        <stop offset="60%" stopColor="#f8c898" />
        <stop offset="100%" stopColor="#e09858" />
      </radialGradient>
      <linearGradient id="bkDress" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f07060" />
        <stop offset="100%" stopColor="#c04840" />
      </linearGradient>
      <linearGradient id="bkApron" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="100%" stopColor="#e8e8e4" />
      </linearGradient>
      <linearGradient id="bkShoe" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#2e1a0c" />
        <stop offset="100%" stopColor="#140806" />
      </linearGradient>
      <linearGradient id="bkHat" x1="20%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="100%" stopColor="#e4e4df" />
      </linearGradient>
      <radialGradient id="bkDish" cx="40%" cy="35%" r="65%">
        <stop offset="0%" stopColor="#f8e8c0" />
        <stop offset="100%" stopColor="#c8a060" />
      </radialGradient>
      <linearGradient id="bkCrust" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f5c460" />
        <stop offset="55%" stopColor="#d4940a" />
        <stop offset="100%" stopColor="#a86808" />
      </linearGradient>
      <radialGradient id="bkFill" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#e85040" />
        <stop offset="100%" stopColor="#a02818" />
      </radialGradient>
      <filter id="bkDrop" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.25" />
      </filter>
    </defs>

    {/* Ground shadow */}
    <ellipse cx="116" cy="341" rx="68" ry="9" fill="rgba(0,0,0,0.2)" />

    {/* === SHOES — clean rounded flats === */}
    {/* Left shoe */}
    <path d="M 74 308 Q 72 298 80 293 Q 94 289 108 296 Q 115 303 112 314 Q 104 323 82 321 Q 70 316 74 308 Z"
      fill="url(#bkShoe)" stroke="#0a0604" strokeWidth="1.5" />
    <path d="M 82 294 Q 96 290 108 296" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="2" strokeLinecap="round" />
    <path d="M 72 313 Q 92 320 112 313" fill="none" stroke="#1e0c06" strokeWidth="1.5" strokeLinecap="round" />
    {/* Left shoe strap */}
    <path d="M 78 300 Q 94 296 108 300" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="2.5" strokeLinecap="round" />

    {/* Right shoe */}
    <path d="M 124 310 Q 122 299 130 294 Q 146 290 160 297 Q 168 305 164 316 Q 156 325 134 323 Q 120 317 124 310 Z"
      fill="url(#bkShoe)" stroke="#0a0604" strokeWidth="1.5" />
    <path d="M 132 295 Q 146 291 160 297" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="2" strokeLinecap="round" />
    <path d="M 122 315 Q 142 322 166 315" fill="none" stroke="#1e0c06" strokeWidth="1.5" strokeLinecap="round" />
    {/* Right shoe strap */}
    <path d="M 128 302 Q 144 298 160 302" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="2.5" strokeLinecap="round" />

    {/* === DRESS SKIRT === */}
    {/* Left skirt leg */}
    <path d="M 80 264 Q 72 284 70 308 Q 82 318 104 316 Q 110 308 108 292 Q 106 278 103 264 Z"
      fill="url(#bkDress)" stroke="#903028" strokeWidth="2" />
    {/* Right skirt leg */}
    <path d="M 130 264 Q 136 282 140 300 Q 150 312 166 308 Q 172 298 167 284 Q 162 272 155 264 Z"
      fill="url(#bkDress)" stroke="#903028" strokeWidth="2" />
    {/* Skirt highlights */}
    <path d="M 84 266 Q 78 286 76 304" stroke="rgba(255,160,130,0.28)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M 162 268 Q 166 286 165 302" stroke="rgba(255,160,130,0.28)" strokeWidth="2.5" fill="none" strokeLinecap="round" />

    {/* === DRESS BODY === */}
    <path d="M 75 158 Q 65 186 63 227 Q 62 250 70 264 L 182 264 Q 190 250 189 227 Q 187 186 177 158 Z"
      fill="url(#bkDress)" stroke="#903028" strokeWidth="2.5" />
    {/* Dress shade panel */}
    <path d="M 75 158 Q 67 186 65 227 Q 64 250 70 264 L 116 264 L 116 158 Z"
      fill="rgba(0,0,0,0.08)" />
    {/* V-neck under apron */}
    <path d="M 101 156 L 89 180 L 116 188 L 143 180 L 131 156 Z"
      fill="#e05050" stroke="#a03030" strokeWidth="1" />

    {/* === APRON === */}
    {/* Bib */}
    <path d="M 96 156 L 86 184 L 116 192 L 146 184 L 136 156 Z"
      fill="url(#bkApron)" stroke="#d8d8d4" strokeWidth="1.5" />
    {/* Body */}
    <path d="M 86 184 Q 84 218 86 252 L 146 252 Q 148 218 146 184 Z"
      fill="url(#bkApron)" stroke="#d8d8d4" strokeWidth="1.5" />
    {/* Waist ties */}
    <path d="M 86 188 Q 72 185 62 190" stroke="#eeeeea" strokeWidth="4" fill="none" strokeLinecap="round" />
    <path d="M 146 188 Q 160 185 170 190" stroke="#eeeeea" strokeWidth="4" fill="none" strokeLinecap="round" />
    {/* Pocket */}
    <rect x="103" y="212" width="28" height="22" rx="4" fill="white" stroke="#d4d4d0" strokeWidth="1.5" />
    {/* Flour dustings */}
    <ellipse cx="98" cy="227" rx="10" ry="5" fill="rgba(255,255,255,0.58)" transform="rotate(-20,98,227)" />
    <ellipse cx="134" cy="220" rx="7" ry="4" fill="rgba(255,255,255,0.46)" transform="rotate(12,134,220)" />
    {/* Hem ruffle */}
    <path d="M 86 252 Q 101 260 116 262 Q 131 260 146 252"
      fill="none" stroke="#ccccca" strokeWidth="2" strokeLinecap="round" />

    {/* === ARMS — clean single-direction paths === */}
    {/* Left arm shadow */}
    <path d="M 76 162 Q 60 186 56 220 Q 55 228 56 232"
      fill="none" stroke="#111" strokeWidth="24" strokeLinecap="round" opacity="0.12" />
    {/* Left arm dress color */}
    <path d="M 76 162 Q 60 186 56 220 Q 55 228 56 232"
      fill="none" stroke="#f07060" strokeWidth="20" strokeLinecap="round" />
    {/* Left sleeve end (darker cuff band) */}
    <path d="M 57 220 Q 55 226 56 232" stroke="#c84040" strokeWidth="22" fill="none" strokeLinecap="round" />
    {/* Left hand */}
    <ellipse cx="56" cy="234" rx="11" ry="9" fill="url(#bkSkin)" stroke="#c09858" strokeWidth="1.5" />

    {/* Right arm shadow */}
    <path d="M 156 162 Q 174 186 178 220 Q 179 228 178 234"
      fill="none" stroke="#111" strokeWidth="24" strokeLinecap="round" opacity="0.12" />
    {/* Right arm dress color */}
    <path d="M 156 162 Q 174 186 178 220 Q 179 228 178 234"
      fill="none" stroke="#f07060" strokeWidth="20" strokeLinecap="round" />
    {/* Right sleeve end cuff */}
    <path d="M 179 220 Q 180 226 178 234" stroke="#c84040" strokeWidth="22" fill="none" strokeLinecap="round" />
    {/* Right hand */}
    <ellipse cx="178" cy="236" rx="11" ry="9" fill="url(#bkSkin)" stroke="#c09858" strokeWidth="1.5" transform="rotate(12,178,236)" />

    {/* === PIE — golden lattice, steam rising === */}
    {/* Dish bottom */}
    <ellipse cx="200" cy="252" rx="32" ry="12" fill="url(#bkDish)" stroke="#a07838" strokeWidth="2" filter="url(#bkDrop)" />
    {/* Dish sides */}
    <path d="M 168 246 Q 200 254 232 246 L 232 252 Q 200 260 168 252 Z"
      fill="#d4a860" stroke="#a07838" strokeWidth="1.5" />
    {/* Pie crust edge */}
    <ellipse cx="200" cy="242" rx="28" ry="11" fill="url(#bkCrust)" stroke="#a06010" strokeWidth="2" />
    {/* Crust top */}
    <ellipse cx="200" cy="238" rx="25" ry="9" fill="#e8b040" />
    {/* Filling */}
    <ellipse cx="200" cy="236" rx="17" ry="6" fill="url(#bkFill)" />
    {/* Lattice */}
    <line x1="185" y1="235" x2="215" y2="235" stroke="#c4880a" strokeWidth="2" opacity="0.6" />
    <line x1="200" y1="229" x2="200" y2="245" stroke="#c4880a" strokeWidth="2" opacity="0.6" />
    <line x1="189" y1="231" x2="211" y2="241" stroke="#c4880a" strokeWidth="1.5" opacity="0.5" />
    <line x1="189" y1="241" x2="211" y2="231" stroke="#c4880a" strokeWidth="1.5" opacity="0.5" />
    {/* Crust bumps */}
    <ellipse cx="175" cy="239" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    <ellipse cx="183" cy="232" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    <ellipse cx="192" cy="228" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    <ellipse cx="200" cy="226" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    <ellipse cx="208" cy="228" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    <ellipse cx="217" cy="232" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    <ellipse cx="225" cy="239" rx="5" ry="4" fill="#f0c050" stroke="#a87020" strokeWidth="1" />
    {/* Steam wisps */}
    <path d="M 191 222 Q 189 214 192 206 Q 195 198 193 190" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M 200 220 Q 198 212 201 204" fill="none" stroke="rgba(255,255,255,0.45)" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M 209 222 Q 211 214 208 207" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" />

    {/* === NECK === */}
    <rect x="103" y="132" width="26" height="28" rx="10" fill="url(#bkSkin)" stroke="#c09858" strokeWidth="2" />

    {/* === HEAD === */}
    <ellipse cx="116" cy="94" rx="54" ry="58" fill="url(#bkHead)" stroke="#111" strokeWidth="2.5" filter="url(#bkDrop)" />
    {/* Head highlight */}
    <ellipse cx="100" cy="72" rx="22" ry="18" fill="rgba(255,255,255,0.24)" transform="rotate(-20,100,72)" />
    {/* Chin shadow */}
    <ellipse cx="116" cy="140" rx="30" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* === HAIR — vibrant ginger === */}
    {/* Main hair mass (top hidden by hat, sides visible) */}
    <path d="M 64 84 Q 66 40 116 36 Q 166 40 168 84 Q 153 54 116 52 Q 79 54 64 84 Z"
      fill="#c04010" stroke="#8a2a06" strokeWidth="1.5" />
    {/* Left side hair — flows below hat */}
    <path d="M 64 84 Q 56 100 56 122 Q 60 106 68 108 Q 62 100 64 84 Z"
      fill="#c04010" stroke="#8a2a06" strokeWidth="1" />
    {/* Left side hair wave curl */}
    <path d="M 56 106 Q 52 116 58 124" fill="none" stroke="#8a2a06" strokeWidth="1.8" strokeLinecap="round" />
    {/* Right side hair */}
    <path d="M 168 84 Q 176 100 176 122 Q 172 106 164 108 Q 170 100 168 84 Z"
      fill="#c04010" stroke="#8a2a06" strokeWidth="1" />
    {/* Right side hair wave curl */}
    <path d="M 176 106 Q 180 116 174 124" fill="none" stroke="#8a2a06" strokeWidth="1.8" strokeLinecap="round" />
    {/* Hair highlight / sheen */}
    <path d="M 88 42 Q 116 34 142 42" fill="none" stroke="rgba(255,140,50,0.78)" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M 94 48 Q 116 41 136 48" fill="none" stroke="rgba(255,200,80,0.45)" strokeWidth="2.5" strokeLinecap="round" />

    {/* === CHEF'S TOQUE — tall and impressive === */}
    {/* Hat band */}
    <rect x="60" y="66" width="112" height="24" rx="4" fill="url(#bkHat)" stroke="#d4d4d0" strokeWidth="1.5" />
    {/* Toque tall puff body */}
    <path d="M 68 70 Q 66 8 116 4 Q 166 8 164 70 Z"
      fill="url(#bkHat)" stroke="#d4d4d0" strokeWidth="1.5" />
    {/* Toque top dome */}
    <ellipse cx="116" cy="10" rx="49" ry="17" fill="white" stroke="#d8d8d4" strokeWidth="1.5" />
    {/* Puff highlight — soft gloss */}
    <ellipse cx="98" cy="6" rx="22" ry="11" fill="rgba(255,255,255,0.86)" transform="rotate(-10,98,6)" />
    {/* Vertical fold lines for realism */}
    <path d="M 84 70 Q 80 36 92 10" fill="none" stroke="rgba(180,180,176,0.55)" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M 116 70 Q 116 32 116 6" fill="none" stroke="rgba(180,180,176,0.45)" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M 148 70 Q 152 36 140 10" fill="none" stroke="rgba(180,180,176,0.55)" strokeWidth="1.5" strokeLinecap="round" />
    {/* Band upper fold line */}
    <line x1="60" y1="73" x2="172" y2="73" stroke="#c8c8c4" strokeWidth="1.5" />
    {/* Band lower curve */}
    <path d="M 60 90 Q 116 95 172 90" fill="none" stroke="#c0c0bc" strokeWidth="1" />

    {/* === EARS === */}
    <ellipse cx="62" cy="96" rx="10" ry="13" fill="url(#bkSkin)" stroke="#c09858" strokeWidth="2" />
    <path d="M 64 88 Q 59 96 64 104" fill="none" stroke="#c09858" strokeWidth="1.5" strokeLinecap="round" />
    <ellipse cx="170" cy="96" rx="10" ry="13" fill="url(#bkSkin)" stroke="#c09858" strokeWidth="2" />
    <path d="M 168 88 Q 173 96 168 104" fill="none" stroke="#c09858" strokeWidth="1.5" strokeLinecap="round" />

    {/* === EYEBROWS — ginger-match === */}
    <path d="M 86 74 Q 96 68 106 72" fill="none" stroke="#902808" strokeWidth="2.8" strokeLinecap="round" />
    <path d="M 126 72 Q 136 68 148 74" fill="none" stroke="#902808" strokeWidth="2.8" strokeLinecap="round" />

    {/* === EYES — vivid green === */}
    <ellipse cx="96" cy="88" rx="13" ry="12" fill="white" stroke="#222" strokeWidth="1.5" />
    <ellipse cx="136" cy="88" rx="13" ry="12" fill="white" stroke="#222" strokeWidth="1.5" />
    {/* Outer iris — bright green */}
    <circle cx="97" cy="89" r="8" fill="#2ea040" />
    <circle cx="137" cy="89" r="8" fill="#2ea040" />
    {/* Inner iris */}
    <circle cx="97" cy="89" r="5.5" fill="#1c6828" />
    <circle cx="137" cy="89" r="5.5" fill="#1c6828" />
    {/* Iris texture rays */}
    <path d="M97 81 L97 84 M104 84 L102 86 M104 94 L102 92 M97 97 L97 94 M90 94 L92 92 M90 84 L92 86"
      stroke="rgba(80,200,70,0.4)" strokeWidth="1" strokeLinecap="round" />
    <path d="M137 81 L137 84 M144 84 L142 86 M144 94 L142 92 M137 97 L137 94 M130 94 L132 92 M130 84 L132 86"
      stroke="rgba(80,200,70,0.4)" strokeWidth="1" strokeLinecap="round" />
    {/* Pupils */}
    <circle cx="98" cy="90" r="4" fill="#0a1808" />
    <circle cx="138" cy="90" r="4" fill="#0a1808" />
    {/* Eye shines */}
    <circle cx="100" cy="86" r="2.5" fill="white" />
    <circle cx="140" cy="86" r="2.5" fill="white" />
    <circle cx="95" cy="92" r="1.2" fill="rgba(255,255,255,0.55)" />
    <circle cx="135" cy="92" r="1.2" fill="rgba(255,255,255,0.55)" />
    {/* Lashes */}
    <path d="M 84 82 Q 90 77 97 80" fill="none" stroke="#902808" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M 124 80 Q 130 77 138 82" fill="none" stroke="#902808" strokeWidth="1.8" strokeLinecap="round" />

    {/* === NOSE === */}
    <path d="M 116 100 Q 110 112 108 116 Q 116 120 124 116 Q 122 112 116 100" fill="#f0b070" />
    <path d="M 109 116 Q 116 120 123 116" fill="none" stroke="#d08040" strokeWidth="2" strokeLinecap="round" />

    {/* === MOUTH — warm joyful smile === */}
    <path d="M 97 126 Q 116 140 135 126" fill="none" stroke="#c06040" strokeWidth="3" strokeLinecap="round" />
    <path d="M 100 128 Q 116 136 132 128 Q 116 132 100 128 Z" fill="white" opacity="0.9" />
    {/* Dimples */}
    <circle cx="93" cy="124" r="2.8" fill="rgba(230,100,60,0.28)" />
    <circle cx="139" cy="124" r="2.8" fill="rgba(230,100,60,0.28)" />

    {/* Cheek blush — rosy from oven warmth */}
    <ellipse cx="80" cy="111" rx="16" ry="11" fill="rgba(240,100,80,0.3)" />
    <ellipse cx="152" cy="111" rx="16" ry="11" fill="rgba(240,100,80,0.3)" />
  </svg>
);

export default BakerCharacter;
